import React, {memo, type FC} from 'react'
import clsx from 'clsx'

/** Tool stdout / result text: monospace, pre-wrapped, no syntax highlighting or code-block chrome. */
export const OmicsFormattedTextBlock: FC<{text: string; className?: string}> = memo(({text, className}) => {
  if (!text.trim()) return null
  return <pre className={clsx('omics-formatted-text', className)}>{text}</pre>
})

OmicsFormattedTextBlock.displayName = 'OmicsFormattedTextBlock'
